import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import {
  setLookDemoPointsClicked,
  setLookIntroStep,
  setLookOpened, setLookPageOpened,
  setLookParentKeys
} from "../../../../actions/lookFunctions";
import LookIntroPopper from "../lookIntro/lookIntroPopper";
import EditIcon from "@mui/icons-material/Edit";
import {LOOK_INTRO_STEPS, LOOK_INTRO_STEPS_MOBILE, LOOK_OPENED_TYPES} from "../../core/constants";
import {getCurrentLayout} from "../../../appLayout";
import LookSideBarEditButtonPopper from "./lookSideBarEditButtonPopper";
import WithDemoShow from "../../hocs/withDemoShow";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {ROUTES} from "../../../../routes";
import {getLookIdUrl} from "../lookFunctions2";

const LookSideBarEditButton = (props) => {

  const {intl, lookOpened, setLookOpened, popupCloseClick, disabled, introStep, setLookIntroStep, sidebarButtonClicked,
    lookParentKeys, setLookParentKeys, visualizersLoadedLength, setLookDemoPointsClicked, history, lookPageOpened,
    setLookPageOpened, isMobile} = props;
  const anchorRef = useRef(null);

  const neededIntroStep = isMobile ? LOOK_INTRO_STEPS_MOBILE.wallsAndFloor : LOOK_INTRO_STEPS.wallsAndFloor;

  const lookButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarEdit);
    if (!visualizersLoadedLength) {
      return false
    }
    if (introStep === neededIntroStep) {
      setLookIntroStep(introStep + 1);
      return false;
    }
    setLookOpened(lookOpened ? null : LOOK_OPENED_TYPES.edit);
    if (!lookOpened) {
      setLookDemoPointsClicked(true);
    }
    if (lookOpened || lookPageOpened) {
      if (lookPageOpened) {
        setLookPageOpened("");
        history.push(getLookIdUrl());
      } else {
        history.push(ROUTES.home);
      }
    }
    if (!lookOpened && !lookParentKeys.length) {
      const layout = getCurrentLayout();
      const allFeatures = layout.getActiveFeatures(false);
      if (allFeatures[0]) {
        setLookParentKeys(allFeatures[0].partId);
      }
    }
    if (popupCloseClick) {
      popupCloseClick();
    }
    sidebarButtonClicked();
  }

  const realDisabled = disabled || !!(introStep && (introStep !== neededIntroStep));

  return (
    <li className="look-sidebar__list-item">
      <Tooltip title={intl.formatMessage({id:"tooltip.editLook"})} placement="right">
        <IconButton aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                    ref={anchorRef}
                    disabled={realDisabled}
                    className={"look-icon look-sidebar__button" + (lookOpened ? " look-icon--active" : "")
                      + (introStep === neededIntroStep ? " look-sidebar__button--intro" : "")}
                    onClick={lookButtonClick}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      {/*<span className="look-tooltip"><FormattedMessage id="tooltip.home"/></span>*/}
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={neededIntroStep}
                       toolTipText={"look.intro.step2.tooltip"}/>
      {anchorRef ? (
        <WithDemoShow>
          {(showPoints) => <LookSideBarEditButtonPopper anchorRef={anchorRef} showPoints={showPoints && !lookOpened}/>}
        </WithDemoShow>
      ) : null}
    </li>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, isMobile} = store.serverState;
  const {lookOpened, lookPageOpened, introStep, lookParentKeys} = store.lookState;

  return {
    lookOpened,
    lookPageOpened,
    introStep,
    lookParentKeys,
    visualizersLoadedLength: visualizersLoaded.length,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookIntroStep,
  setLookParentKeys,
  setLookDemoPointsClicked,
  setLookPageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookSideBarEditButton)
  )
)
